import { combineReducers } from "redux";
import { createPaginatedList } from "MODULES/shared/pagination";
import api from "APP_ROOT/api";

export const pagination = createPaginatedList({
  listId: "reports",
  fetch: api.reports.search,
  stateLocator: state => state.reports.main
});

export default combineReducers({
  main: pagination.paginator
});



// WEBPACK FOOTER //
// ./app/modules/Admin/Reports/pagination.js